// extracted by mini-css-extract-plugin
export default {"table":"ModalWhatsNewVersion2_table__iZ-vI","title":"ModalWhatsNewVersion2_title__Lnmik"};